export const BUILD_VERSION = '1791223807';
